import { createFileRoute } from '@tanstack/react-router'
import SignupView from "../../signup/SignupView.tsx";

export const Route = createFileRoute('/signup/$signup_type')({
  component: RouteComponent,
})

function RouteComponent() {
  const {signup_type} = Route.useParams();
  const initialRole = signup_type === 'organizer' ? 'organizer' : signup_type === 'player' ? 'player' : undefined;
  // Key by signup_type: /signup/player and /signup/organizer share this route, so without a key a
  // param change re-renders instead of remounting and the role/step initial state would go stale.
  return <SignupView key={signup_type} initialRole={initialRole} />
}
